import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetRelatedArticlesResponse } from './types';

export const getRelatedArticles = async (
	articleId: number,
	limit = 10
): Promise<GetRelatedArticlesResponse> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/related-articles?articleId=${articleId}&limit=${limit}`;

	const response: GetRelatedArticlesResponse = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching related articles:', error);
			return [];
		});

	return response;
};
